import React, { useState } from "react";
import Buyinginfo from "./Buyinginfo";
import ShippingSelection from "./ShippingSelection";
import { TransitionGroup } from "react-transition-group";
import { CSSTransition } from "react-transition-group";
import ConfirmDetaiils from "./ConfirmDetaiils";

const Buying = () => {
  const [step, setStep] = useState(1);

  const handleContinue = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));
  };

  return (
    <div className="buying">
      <div className="row h-100">
        <div className="col-lg-7 d-none d-lg-block">
          <div className="d-flex align-items-center justify-content-center h-100 ">
          <img className="w-75" src="/assets/images/Quater.png" alt="Quater" />
          </div>
        </div>
        <div className="col-lg-5">
          <div className="inner-buy position-relative h-100">
            {step > 0 && step <= 3 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mb-5"
                width="32"
                height="28"
                viewBox="0 0 32 28"
                fill="none"
                onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                <path
                  d="M0.700962 12.701C-0.0164757 13.4184 -0.0164756 14.5816 0.700962 15.299L12.3923 26.9904C13.1097 27.7078 14.2729 27.7078 14.9904 26.9904C15.7078 26.2729 15.7078 25.1097 14.9904 24.3923L4.59808 14L14.9904 3.6077C15.7078 2.89026 15.7078 1.72706 14.9904 1.00962C14.2729 0.292182 13.1097 0.292182 12.3923 1.00962L0.700962 12.701ZM32 12.1629L2 12.1629L2 15.8371L32 15.8371L32 12.1629Z"
                  fill="white"
                />
              </svg>
            )}

            <div className={`contentss ${step === 1 ? "show" : "hide"}`}>
              <Buyinginfo />
            </div>
            <div className={`contentss ${step === 2 ? "show" : "hide"}`}>
              <ShippingSelection />
            </div>
            <div className={`contentss ${step === 3 ? "show" : "hide"}`}>
              <ConfirmDetaiils />
            </div>

            {step < 3 && (
              <a className="next" onClick={handleContinue}>
                Continue
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buying;
